import { useState, useEffect } from 'react';
import { useApiService } from '@/hooks/useApiService';
import { FormationSingleColumn } from './FormationSingleColumn';
import { FormationType } from '../types';

// type FormationColumnsProps = {
//     isGettingStartedOpen: boolean;
//     setIsGettingStartedOpen: (isOpen: boolean) => void;
// };

function FormationColumns({
    isModalOpen,
    setIsModalOpen,
}: {
    isModalOpen: boolean;
    setIsModalOpen: (value: boolean) => void;
}) {
    const [versionFormations, setFormations] = useState<FormationType[]>([]);
    const { getFormations } = useApiService();

    useEffect(() => {
        const fetchData = async () => {
            const versionFormations = await getFormations();
            setFormations(versionFormations);
        };

        fetchData().catch(console.error);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-2">
            {versionFormations.map((versionFormation: FormationType, index: number, { length }) => {
                return (
                    <div key={index}>
                        <FormationSingleColumn
                            key={versionFormation._id}
                            versionFormation={versionFormation}
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                        />
                        {index < length - 1 ? (
                            <div className="flex flex-col border-t  border-[#000000] xl:border-l xl:border-t-inherit"></div>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
}

export default FormationColumns;
